import {FC, useMemo} from "react"
import {MarkdownAtom} from "../model/markdown/MarkdownText"
import {markdownService} from "../service/markdownService"
import {MarkdownBlockRenderer} from "./MarkdownBlockRenderer"
import './MarkdownViewer.less'

interface Props {
    sourceCode: string
    compactMode: boolean
    onToggleCheckBox: (atom: MarkdownAtom) => void
}

export const MarkdownViewer: FC<Props> = ({
                                              sourceCode,
                                              compactMode,
                                              onToggleCheckBox,
                                          }) => {
    const parsed = useMemo(() => markdownService.parseMarkdown(sourceCode), [sourceCode])

    const classes = ["markdownViewer"]
    if (compactMode) {
        classes.push('compact')
    }

    const tryOpenLink = (event: React.MouseEvent<HTMLDivElement>) => {
        if (event.button !== 0) {
            return
        }
        let target: HTMLElement | null = event.target as HTMLElement
        while (target !== null) {
            if (target.tagName.toLowerCase() === 'a') {
                event.preventDefault()
                event.stopPropagation()
                const url = target.getAttribute('href')
                if (url) {
                    window.open(url, '_blank')
                }
                return
            }
            target = target.parentElement
        }
    }

    return (
        <div className={classes.join(' ')} onMouseDown={tryOpenLink}>
            {parsed.blocks.map(block => (
                <MarkdownBlockRenderer key={block.id}
                                       block={block}
                                       onToggleCheckBox={onToggleCheckBox}
                />
            ))}
        </div>
    )
}
